import { useCallback } from 'react'
import {
  ApiGetWithToken,
	ApiDeleteWithToken,
	ApiPatchWithToken,
	ApiPostWithToken,
	useApiFetch,
	useApiPost
} from 'shared/api'
import {
	searchsGuideLineApi,
	searchsGuideLineApiBy
} from 'interface/endpoints'
import {
	SearchsGuideLineFormData,
  SearchsGuideLineResult,
  SearchsGuideLineResultList
} from './types'

export * from './types'

export const useListSearchsGuideLine = (
  searchId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!searchId) return null
      return ApiGetWithToken<SearchsGuideLineResultList>(
        apiAccess,
        searchsGuideLineApi(searchId, "/list"),
        cancelToken
  		)
    },
		[searchId]
	)
)

export const useGetSearchsGuideLine = (
  searchId?: number | null,
	searchsGuideLineId?: number | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
      if (!searchId || !searchsGuideLineId) return null
      return ApiGetWithToken<SearchsGuideLineResult>(
        apiAccess,
        searchsGuideLineApiBy(searchId, searchsGuideLineId),
        cancelToken
  		)
    },
		[searchId, searchsGuideLineId]
	)
)

export const usePostSearchsGuideLine = (
  searchId: number, 
	callback?: {
    onPosted?: (result: SearchsGuideLineResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<SearchsGuideLineFormData, SearchsGuideLineResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsGuideLineApi(searchId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useEditSearchsGuideLine = (
  searchId: number,
	searchsGuideLineId: number, 
	callback?: {
    onEditted?: (result: SearchsGuideLineResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<SearchsGuideLineFormData, SearchsGuideLineResult>(
	useCallback(
		(apiAccess, cancelToken, form, webSocketId) => {
			return ApiPatchWithToken(
				apiAccess,
        searchsGuideLineApiBy(searchId, searchsGuideLineId),
				form,
				cancelToken,
				webSocketId
			)
		},
		[searchId, searchsGuideLineId]
	),
	useCallback(
		(result) => {
			if (callback?.onEditted) callback.onEditted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useSortSearchsGuideLine = (
  searchId: number, 
	callback?: {
    onPosted?: (result: SearchsGuideLineResult) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number[], SearchsGuideLineResult>(
	useCallback(
		(apiAccess, cancelToken, ids, webSocketId) => {
			return ApiPostWithToken(
				apiAccess,
        searchsGuideLineApi(searchId, "/sort"),
				ids,
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onPosted) callback.onPosted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)

export const useRemoveSearchsGuideLine = (
  searchId: number, 
	callback?: {
    onDeleted?: (searchId: number) => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onError?: (reason: any) => void
  }
) => useApiPost<number, number>(
	useCallback(
		(apiAccess, cancelToken, searchsGuideLineId, webSocketId) => {
			return ApiDeleteWithToken(
				apiAccess,
        searchsGuideLineApiBy(searchId, searchsGuideLineId),
				cancelToken,
				webSocketId
			)
		},
		[searchId]
	),
	useCallback(
		(result) => {
			if (callback?.onDeleted) callback.onDeleted(result)
			return result
		},
		[callback]
	),
	useCallback(
		(reason) => {
      if (callback?.onError) callback?.onError(reason)
		},
		[callback]
	)
)
